import React, { useContext, useEffect, useState } from 'react';
import {
  useLazyDataModel,
  params,
  string,
  extend
} from '@thd-nucleus/data-sources';
import PropTypes from 'prop-types';
import { ExperienceContext, useDomPath } from '@thd-nucleus/experience-context';
import { Buybox } from '@thd-olt-component-react/buybox';

export const PaintReorderBuyBox = ({
  configId, brandId, itemId, upcCode, storeId, sticky, isB2BCustomer, disableBODFS, disableSTH, disableBOSS
}) => {
  const [newCartReqParams, setNewCartReqParams] = useState({});
  const [paintConfigErrorMessage, setPaintConfigErrorMessage] = useState('');
  const [makePaintConfigCall, paintConfigData] = useLazyDataModel('paintConfiguration', {
    ssr: false,
    fetchPolicy: 'network-only',
  });
  const [path] = useDomPath();
  const { channel } = useContext(ExperienceContext);
  const getHost = () => {
    let host = 'https://www.homedepot.com';
    if (typeof window !== 'undefined') {
      const origin = window.location.origin;
      host = origin.match(/local/g) ? 'https://www.homedepot.com' : origin;
    }
    return host;
  };
  useEffect(() => {
    if (!paintConfigData?.called) return;
    if (paintConfigData?.data) {
      const newConfigId = paintConfigData?.data?.paintConfiguration?.configId;
      if (!newConfigId) {
        setPaintConfigErrorMessage('Something went wrong. We are not able to add this paint to your cart.');
      } else {
        setPaintConfigErrorMessage('');
        const cartReqParams = { ...newCartReqParams };
        cartReqParams.paintConfiguration = { configurationId: newConfigId };
        const cartOptions = {
          channel,
          host: getHost(),
          misship: false,
          paypal: false
        };

        window.LIFE_CYCLE_EVENT_BUS.trigger('cart.add-to-cart', {
          cartReqParams,
          cartOptions,
          path
        });
      }
    }
  }, [paintConfigData?.data, paintConfigData]);

  const onClickPassThrough = (updatedReqParams) => {
    setNewCartReqParams(updatedReqParams);
    makePaintConfigCall({
      variables: {
        storeId,
        originalConfigId: configId,
        brandId: brandId?.toString(),
        upcCode
      },
      skip: !itemId,
    });
  };

  return (
    <Buybox
      itemId={itemId}
      sticky={sticky}
      showCards
      originalConfigId={configId}
      disableDelivery={!!configId}
      hideProReferral={isB2BCustomer}
      showFavoriteAndQuote={false}
      onClickPassThrough={onClickPassThrough}
      disableSTH={disableSTH}
      disableBODFS={disableBODFS}
      disableBOSS={disableBOSS}
      hideInstantCheckout
      hidePaypalCheckout
      paintConfigErrorMessage={paintConfigErrorMessage}
    />
  );
};
PaintReorderBuyBox.dataModel = extend({
  paintConfiguration:
      params({
        storeId: string()
          .isRequired(),
        originalConfigId: string()
          .isRequired(),
        brandId: string()
          .isRequired(),
        upcCode: string()
          .isRequired()
      })
        .shape({
          configId: string()
        })
},
Buybox
);

PaintReorderBuyBox.propTypes = {
  configId: PropTypes.string,
  brandId: PropTypes.number,
  itemId: PropTypes.string,
  upcCode: PropTypes.string,
  storeId: PropTypes.string,
  sticky: PropTypes.bool,
  isB2BCustomer: PropTypes.bool,
  disableBODFS: PropTypes.bool,
  disableSTH: PropTypes.bool,
  disableBOSS: PropTypes.bool
};
PaintReorderBuyBox.defaultProps = {
  configId: null,
  brandId: null,
  itemId: null,
  upcCode: null,
  storeId: null,
  sticky: true,
  isB2BCustomer: false,
  disableBODFS: false,
  disableSTH: false,
  disableBOSS: false
};
